export const pathNames = {
    loginPath: 'login',
    signUpPath: 'signup',
    subaccountSignUpPathPath: 'subaccount/signup',
    aiAgentConfigurationPath: 'ai-agent-configuration',
    oauthAuthSuccessPath: 'oauth/auth-success',
    rebillingPath: 'rebilling',
    customDomain: 'custom-domain',
    activationPath:'activation',
    validateAccountPath: 'validate-account',
    userSettingsPath: 'user-settings',
    userPhoneNumbersPath: 'user-phone-numbers',
    lostPasswordPath: 'reset-password',
    paymentPlansPath: 'payment-plans',
    paymentSuccessPath: 'payment-success',
    paymentCancelPath: 'payment-cancel',
    subaccountPath: 'subaccount',
    adminDashboardPath: 'admin-dashboard',
    path404: '404',
    notFoundPath: 'not-found',
    pathSuffix: '../'
};

export const variablePathNames = {
    lostPasswordPathVariable: 'link',
    validateAccountPathVariable: 'email',
    aiAgentIdConfigPathVariable: 'aiAgentId',
    aiSelectIndexConfigPathVariable: 'selectedIndex',
    oauthCallBackPathVariable: 'oauth-callback',
    oauthCallBackIntegrationIdPathVariable: 'oauth-callback-integrationId',
    paymentPlanPathVariable: 'paymentPlan',
    activationPathVariable: 'link',
    subaccountPathVariable:'link',
    subaccountUserIdPathVariable:'userId',
  }

export const getUrlPathWithSuffix = (path:string): string => {
    return pathNames.pathSuffix + path;
}
